module.exports = __webpack_public_path__ + "img/intro16.240e7a41.jpg";